export default __webpack_public_path__ + "static/media/red-bell.417860ae.svg";